export default __webpack_public_path__ + "static/media/carina-reis.7ed68542.jpg";